module.exports = __webpack_public_path__ + "img/addshipment.1065dac5.png";